import * as React from "react";
import {Document, ICustomerPortalService, ProductsEnum, Types} from "@falcon/services";
import {lazyInject} from "@athena-portal/core";
import {authorize, Overlay} from "@athena-portal/components";
import {FalconAccordion} from "../../../components/FalconAccordion";
import {downloadDocument, trimFileExtension} from "../../../CommonFunctions";
import {DocumentListModal} from "@falcon/plugin-falcon-journey";

interface IProps {
    description: string,
    documents: Document[],
    imageLink: string,
    showBothDocuments: boolean | null,
    originalStartDate: Date,
    product: ProductsEnum | undefined,
    coverTier: string
}

interface IState {
    documentLoaded: boolean;
}

@authorize
export class ActiveDocumentsPanel extends React.Component<IProps, IState> {
    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: Readonly<IProps>) {
        super(props);
        this.state = {
            documentLoaded: false,
        }
    }

    public downloadDocument = (doc: Document) => (event: any): void => {
        this.setState({documentLoaded: true});
        this.customerPortalService.downloadDocument(doc.id).subscribe(
            (documentContent: ArrayBuffer) => {
                if (documentContent) {
                    downloadDocument(documentContent, doc.name);
                }
                    this.setState({documentLoaded: false});
            }
        );
    };

    public render(): React.ReactNode {
        const loading = this.state.documentLoaded;
        if (this.props.documents && this.props.documents.length !== 0) {

            return (
                <div className="widget documents-widget panel mx-3">
                    <img className="mr-2 documents-page-icon" alt="document-icon" src={this.props.imageLink}/>
                    {this.props.description ?
                        <p className="font-weight-bold text-center">{this.props.description}</p> : ""}

                    <ul className="list-unstyled">
                        <FalconAccordion toggleHidden={<div className="toggle">+ Show more</div>}
                                         toggleShown={<div className="toggle">- Show less</div>}>
                            {this.renderDocuments()}
                            <DocumentListModal
                                productName={this.props.product}
                                policyDate={this.props.originalStartDate}
                                isBDIVisible={false}
                                isMLEVisible={false}
                                isAccordion={true}
                                coverTier={this.props.coverTier}
                            />
                        </FalconAccordion>
                    </ul>
                    <Overlay show={loading}/>
                </div>
            );
        } else {
            return <></>;
        }
    }

    private renderDocuments(): React.ReactNode[] {
        return this.props.documents.map((document: Document, index: number) => (
            <li className="media" key={index}>
                <div className="media-body">
                    <div className="row height-0">
                        <div className="col-1"/>
                        <div className="col-11">
                            <div className="dashed-10 ml-3 mr-3"/>
                        </div>
                    </div>
                    <a className="document-download-link" onClick={this.downloadDocument(document)}
                       id={trimFileExtension(document.name)}>
                        <img className="policy-download-icon active-icon" alt="Document download icon"
                             src="/img/Flow-download.svg"/>
                        <h5 className="pt-2 document-name">{document.title}</h5>
                    </a>
                </div>
            </li>
        ));
    }
}
